//import axios from '../../common/request'

const state = {
  permissions: [], //权限
  electricityChannel: [], //电商渠道
  brandData: [], //品牌
  invalidReason: [],//无效原因
  storeRunoff: [],//进店流失
  statusList: [],//状态管理
  electricityChannelStoreNew: [], //电商渠道
  zjsChannelStoreNew:[], //转介绍渠道
}
const getters = {
  permissions: state => {
    let list = state.permissions.map(item => {
      return {
        value: item.id,
        label: item.roleName
      }
    })
    return list
  },
  electricityChannel: state => {
    let list = state.electricityChannel.map(item => {
      return {
        value: item.id,
        label: item.channelName,
        disabled: false,
      }
    })
    return list
  },
  electricityChannelStoreNew: state => {
    let list = state.electricityChannelStoreNew.map(item => {
      return {
        value: item.id,
        label: item.channelName,
        disabled: false,
      }
    })
    return list
  },
  zjsChannelStoreNew: state => {
    let list = state.zjsChannelStoreNew.map(item => {
      return {
        value: item.id,
        label: item.channelName,
        disabled: false,
      }
    })
    return list
  },
  brandData: state => {
    let list = state.brandData.map(item => {
      return {
        value: item.id,
        label: item.brandName,
        brandName: item.brandName,
        id: item.id
      }
    })
    return list
  },
  invalidReason: state => {
    let list = state.invalidReason.map(item => {
      return {
        value: item.id,
        label: item.dicName,
        id: item.id,
        dicName: item.dicName,
        dicCode: item.dicCode,
        dicType: item.dicType,
        spare: item.spare
      }
    })
    localStorage.setItem('InValidReason', JSON.stringify(list))
    return list
  },
  storeRunoff: state => {
    let list = state.storeRunoff.map(item => {
      return {
        value: item.id,
        label: item.dicName,
        id: item.id,
        dicName: item.dicName,
        dicCode: item.dicCode,
        dicType: item.dicType,
        spare: item.spare
      }
    })
    localStorage.setItem('runoffReason', JSON.stringify(list))
    return list
  },
  statusList: state => {
    let list = state.statusList.map(item => {
      return {
        id: item.id,
        classId: item.classId,
        className: item.className,
        statusId: item.statusId,
        statusName: item.statusName,
        fontColor: item.fontColor,
        backColor: item.backColor,
      }
    })
    return list
  },
}
const mutations = {
  setPermissions(state, data) {
    state.permissions = data
  },
  setElectricityChannel(state, data) {
    state.electricityChannel = data
  },
  setElectricityChannelStoreNew(state, data) {
    state.electricityChannelStoreNew = data
  },
  setZjsChannelStoreNew(state, data) {
    state.zjsChannelStoreNew = data
  },
  setBrandData: (state, data) => {
    state.brandData = data
  },
  setInvalidReason(state, data) {
    state.invalidReason = data
  },
  setStoreRunoff(state, data) {
    state.storeRunoff = data
  },
  setStatusList(state, data) {
    state.statusList = data
  },


}
const actions = {
  getPermissions(context, data) {
    let that = data
    that.$http.get('role/get_role_select').then((data) => {
      context.commit('setPermissions', data.data)
    })
  },
  getElectricityChannel(context, data) {
    let that = data
    that.$http.get('channel/get_list_by_type', {
      params: {
        typeId: '1'
      }
    }).then((data) => {
      context.commit('setElectricityChannel', data.data)
    })
  },
  //电商
  getElectricityChannelStoreNew(context, data) {
    let that = data
    that.$http.get('channel/get_list', {
      params: {
        typeId: '1'
      }
    }).then((data) => {
      context.commit('setElectricityChannelStoreNew', data.data)
    })
  },
  //转介绍
  getzjsChannelStoreNew(context, data) {
    let that = data
    that.$http.get('channel/get_list', {
      params: {
        typeId: '2'
      }
    }).then((data) => {
      context.commit('setZjsChannelStoreNew', data.data)
    })
  },
  getBrandData(context, data) {
    let that = data
    that.$http.get('brand/get_list').then((data) => {
      context.commit('setBrandData', data.data)
    })
  },
  getInvalidReasonList(context, data) {
    let that = data
    that.$http.get('/dictionary/get_invalid_reason_list').then((data) => {
      context.commit('setInvalidReason', data.data)
    })
    //  let dict = {
    //    name:'/dictionary/get_invalid_reason_list'
    //  }
    //  const fCallback = data =>{
    //    context.commit('setInvalidReason',data.data)
    //  }
    // // axios(dict,'',fCallback)
  },
  getStoreRunoffList(context, data) {
    let that = data
    that.$http.get('/dictionary/get_run_off_reason_list').then((data) => {
      context.commit('setStoreRunoff', data.data)
    })
    // let dict = {
    //   name:'/dictionary/get_run_off_reason_list'
    // }
    // const fCallback = data =>{
    //   context.commit('setStoreRunoff',data.data)
    // }
    // axios(dict,'',fCallback)
  },
  getStatusList(context, data) {
    let that = data
    that.$http.get('/status/get_company_status_list').then((data) => {
      context.commit('setStatusList', data.data)
    })
    // let dict = {
    //   name:'/status/get_company_status_list'
    // }
    // const fCallback = data =>{
    //   context.commit('setStatusList',data.data)
    // }
    // axios(dict,'',fCallback)
  },

}
export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/model/control.js